<script module>
  export const meta = {
    title: 'Pausly for organizations',
    teaser:
      'Pausly is designed to enhance the workplace experience, acknowledging the\ncritical role employers play in maintaining the health and happiness of their\nemployees. Discover the ins and outs of managing your organization on Pausly and\nexplore the range of features we provide.',
    sort: 3,
  }
</script>
